import { render, staticRenderFns } from "./SocialMediaGallery.vue?vue&type=template&id=7b8f1700&"
import script from "./SocialMediaGallery.vue?vue&type=script&lang=js&"
export * from "./SocialMediaGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports